export default "/images/framework/GameLobby.03dbc1eb.svg?03dbc1eb";